import React from 'react';

const TireIcon = ({ rotated }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 64 64"
      style={{
        transform: rotated ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease',
        cursor: 'pointer'
      }}
    >
      <circle cx="32" cy="32" r="28" fill="#1c1c1c" stroke="#555" strokeWidth="4" />
      <circle cx="32" cy="32" r="10" fill="#ccc" />
      <line x1="32" y1="4" x2="32" y2="60" stroke="#999" strokeWidth="2" />
      <line x1="4" y1="32" x2="60" y2="32" stroke="#999" strokeWidth="2" />
      <line x1="12" y1="12" x2="52" y2="52" stroke="#999" strokeWidth="2" />
      <line x1="52" y1="12" x2="12" y2="52" stroke="#999" strokeWidth="2" />
    </svg>
  );
};

export default TireIcon;